import React from "react"
import { graphql } from "gatsby"
import BlockContent from "@sanity/block-content-to-react"
import styled from "styled-components"

export default function Post({ data: { post } }) {
  return (
    <>
      <PostStyles>
        <header>
          <div>
            <h1>{post.title}</h1>
            <p>{post.date}</p>
            <p>{post.category.title}</p>
            <hr />
          </div>
        </header>

        <div className="body">
          {post._rawBody && <BlockContent blocks={post._rawBody} />}
        </div>
      </PostStyles>
    </>
  )
}

const PostStyles = styled.article`
  background: var(--info-1);
  padding: 10rem 1.5rem;

  p {
    margin-bottom: 4rem;
  }
`
export const query = graphql`
  query($slug: String!) {
    post: sanityPost(slug: { current: { eq: $slug } }) {
      title
      date
      category {
        title
      }
      _rawBody
    }
  }
`
